// newsData.js

// Note the ( main text description ) - accepts markdwn for better styling and layouting.
// Quiuck note per the script i wrote you can run ( npm run img:opt ) to optimize images in the newsData.js file
// This  optimizes the images to 400px and 800px wide versions in the /public/image-fix/news-images/out folder

// The Actual data
export const newsData = [
  // Educating the nexgen
  {
    id: "educate-the-next-gen",
    date: "22-10-15",
    title:
      "European School of Business & Diplomacy Moves to Final Phase of MFHEA Accreditation",
    minidescription:
      "We’re pleased to share a major milestone in our journey towards becoming a fully accredited higher education institution in Malta.",
    maindescription: `
    # ESBD Achieves Major Milestone in Accreditation Journey  

We are delighted to announce a significant step forward in our mission to become a fully accredited higher education institution in Malta.  

The **European School of Business & Diplomacy (ESBD)** has successfully completed **Phase A** of the rigorous accreditation process overseen by the **Malta Further and Higher Education Authority (MFHEA)**. This stage evaluated our **financial standing, due diligence, legal compliance, initial application, and business plan**—all of which we passed with full approval.  

---

## Moving into Phase B  
With Phase A complete, ESBD has advanced to **Phase B**, the final stage of institutional licensing and programme accreditation. As part of this process, we have submitted **18 detailed Self-Assessment Reports**, each carefully aligned with MFHEA’s quality assurance standards.  

These reports showcase our unwavering commitment to:  
- Educational excellence  
- Academic integrity  
- Sustainable institutional development  

Upon successful completion of this phase, ESBD will be officially licensed to operate as a **university-level higher education institution in Malta**.  

---

## What This Means for Our Students  
This achievement brings us closer to launching our first postgraduate programme:  

🎓 **Master of Arts in Global Business & Strategic Leadership**  
📅 **Inaugural intake: March 2026**  

This programme is designed to prepare leaders for today’s interconnected world—grounded in research, innovation, and global perspectives.  

---

## Gratitude and Next Steps  
We extend our heartfelt thanks to all **partners, advisors, and supporters** who have been instrumental in this journey. Transparency remains central to our mission, and we will continue to share updates as we progress toward full accreditation.  

✨ Stay tuned—together, we are building something impactful.  
`,

    image: `/image-fix/random-images/advanced-international-relations.jpg`, // Replace with relevant image if available
    image400:
      "/image-fix/news-images/out/advanced-international-relations-400.jpg",
    image800:
      "/image-fix/news-images/out/advanced-international-relations-800.jpg",
    buttonavaliability: true,
    buttonName: "Apply Now",
    buttonlink: "https://admissions.eusbd.eu/esbd-apply/MA-GBSL/",
  },

  // Program Accreditation
  {
    id: "program-acreditation",
    date: "22-10-15",
    title: "Undergoing Institutional Licensing & Programme Accreditation",
    minidescription:
      "We are excited to announce that we are currently in the process of obtaining our institutional licensing & programme accreditation from the Malta Further & Higher Education Authority (MFHEA). This step will enable us to offer high-quality, accredited courses to future global leaders in diplomacy, politics, & business innovation.",
    maindescription: `
    # ESBD on the Path to Accreditation  

At the **European School of Business & Diplomacy (ESBD)**, we are excited to share that we are currently undergoing the process of obtaining our **institutional licensing and programme accreditation** from the **Malta Further and Higher Education Authority (MFHEA)**.  

This critical step will enable us to offer **high-quality, fully accredited courses** to the next generation of global leaders in **diplomacy, politics, and business innovation**.  

---

## Our Commitment to Excellence  
Once accreditation is achieved, our programmes will:  
- Meet the **highest international educational standards**  
- Prepare students to **navigate the complexities of global leadership**  
- Empower graduates to make an **impact in diplomacy, politics, and business**  

---

✨ Stay tuned as we move closer to launching our accredited programmes—shaping the future of leadership, one student at a time.  
`,
    image: `/image-fix/random-images/r1.jpg`, // Replace with relevant image if available
    image400: "/image-fix/news-images/out/r1-400.jpg",
    image800: "/image-fix/news-images/out/r1-800.jpg",
    buttonavaliability: false,
  },

  // Register Your Interests
  {
    id: "interests",
    date: "22-10-15",
    title: "Register Your Interest to Study on One of Our Programmes",
    minidescription:
      "Ready to shape the future of global leadership? Register your interest in one of our innovative programmes. You'll be the first to know when our accreditation process is completed, ensuring priority consideration for our inaugural cohort.",
    maindescription: `
    # Register Your Interest in Shaping the Future of Global Leadership  

Are you ready to make your mark on the world? 🌍  
At the **European School of Business & Diplomacy (ESBD)**, we invite you to **register your interest** in our upcoming innovative programmes.  

Whether your passion lies in **politics, diplomacy, or leadership**, our courses are designed to equip you with the **skills, knowledge, and confidence** needed to thrive in today’s interconnected world.  

---

## Why Register Early?  
By registering your interest today, you will:  
- Be the **first to know** when our accreditation process is complete and applications open  
- Receive **priority consideration** for our inaugural cohort of future leaders  
- Join an **exclusive network** of ambitious students preparing to drive change globally  

---

✨ Don’t miss this unique opportunity—**register now** and be part of our exciting journey toward shaping the leaders of tomorrow.  
`,
    image: `/Image Assets/Latest NewsImages/InterestToStudyImage.jpg`, // Replace with relevant image if available
    image400: "/image-fix/news-images/out/InterestToStudyImage-400.jpg",
    image800: "/image-fix/news-images/out/InterestToStudyImage-800.jpg",
    buttonavaliability: true,
    buttonName: "Register Now",
    buttonlink: "/register-your-interest",
  },

  // Become our recruitement Agent
  {
    id: "recruitement-agent",
    date: "22-10-15",
    title: "Become Our Recruitment Agent in Your Region",
    minidescription:
      "Join our mission to educate the next generation of world leaders. As a recruitment agent, you'll play a vital role in identifying & recruiting aspiring leaders, with competitive commission rates & ongoing support.",
    maindescription: `
    # Become a Recognised Recruitment Agent with ESBD  

Do you have a **passion for education** and a **strong network in your region**?  
The **European School of Business & Diplomacy (ESBD)** is seeking **dynamic, driven individuals** to join us as **recognised recruitment agents**.  

As a recruitment agent, you will play a vital role in **identifying and recruiting aspiring leaders from across the globe** into our accredited programmes.  

---

## Why Join ESBD’s Global Recruitment Network?  
By becoming a recognised recruitment agent, you’ll gain:  
- 💼 **Competitive commission rates**  
- 🤝 **Ongoing support and resources** from the ESBD team  
- 🎓 Access to **cutting-edge educational opportunities** for students in your region  

---

## Join Our Mission  
At ESBD, our mission is clear: **to educate the next generation of world leaders in diplomacy, business, and politics.**  

Apply now to become a key part of our **global recruitment network**—and help bring **transformative education** to your community and beyond.  

✨ Together, we can shape the future of leadership.  
`,
    image: `/image-fix/random-images/r3.jpg`, // Replace with relevant image if available
    image400: "/image-fix/news-images/out/r3-400.jpg",
    image800: "/image-fix/news-images/out/r3-800.jpg",
    buttonavaliability: true,
    buttonName: "Apply Now",
    buttonlink: "https://admissions.eusbd.eu/esbd-apply/MA-GBSL/",
  },

  //  Smarter assessment: how webinars improved learning outcomes
  {
    id: "smarter-assessment",
    date: "22-10-15",
    title: "Smarter assessment: how webinars improved learning outcomes",
    minidescription:
      "Dr Godofredo “Fred” Utanes tested a simple idea with big pay-off: use live, structured webinars as part of assessment to lift engagement, learning quality, and fairness. His 2024 study documents the approach and results, and it now informs how ESBD designs assessments across modules.",
    maindescription: `

     # Smarter assessment: how webinars improved learning outcomes

*By ESBD Communications*

Dr Godofredo “Fred” Utanes has tested a simple idea with big pay-off: **use live, structured webinars as part of assessment** to lift engagement, learning quality, and fairness. His 2024 study documents the approach and the results, and it is now informing how ESBD designs assessments across modules.

**Source research:** *“Ensuring Quality of Learning by Organising Webinars as an Alternative Assessment for Higher Education Students During the Covid-19 Pandemic Period: An Experiment,”* *International Journal of Behavioral Analytics*, Vol. 4(1), 2024, pp. 11–29. **[Read the paper (PDF).](${"https://ijbmcjournals.org/wp-content/uploads/2024/01/IJBA-4-1-33.pdf"})** 

---

## Why we trialled webinar assessments

Traditional written submissions can mask uneven participation. Group work often suffers from free-riding. In fast-moving subjects, feedback comes late.  
The webinar format tackles these issues head-on:

- Students prepare a short, evidence-based presentation, deliver it live, respond to questions, and receive immediate, criterion-based feedback.  
- It blends academic rigour with professional communication skills.  
- It makes participation visible and assessable.

---

## What changed in student performance

The study reports three practical gains:

1. **Deeper preparation.** Students drew on readings, data, and cases more consistently, because they anticipated questions from peers and tutors.  
2. **Clearer communication.** Live delivery improved structure, clarity, and use of evidence, and reduced copy-paste risks.  
3. **Faster feedback loops.** Moderated Q&A and same-day rubric scoring helped students adjust quickly for subsequent tasks.  

These improvements were most visible in how students justified claims with sources, handled counter-arguments, and linked theory to real decisions.  
**[Read the methodology and findings in the paper.](${"https://ijbmcjournals.org/wp-content/uploads/2024/01/IJBA-4-1-33.pdf"})**

---

## Rubrics, moderation, and integrity

Fairness depends on design. The model uses:

- **Transparent rubrics** shared ahead of time, aligned to learning outcomes.  
- **Dual-marker moderation** where samples are co-scored to calibrate standards.  
- **Verifiable artefacts** such as slide decks, reference lists, and recorded sessions, which support second-marking and academic conduct reviews.  
- **Constructed responses** in Q&A that are hard to outsource, which strengthens academic integrity.  

These elements, documented in Dr Utanes’s article, reduce noise in grading and support consistent standards across cohorts.  
**[See rubric examples in the article.](${"https://ijbmcjournals.org/wp-content/uploads/2024/01/IJBA-4-1-33.pdf"})**

---

## What ESBD is adopting across modules

ESBD will integrate live webinar assessments as part of a broader, research-led assessment mix. Key features include:

- A Week 6/9 live webinar in each module with tutor moderation and structured participation.  
- Clear assessment briefs and published rubrics that map to module learning outcomes.  
- Recorded sessions and artefact submission for quality assurance and moderation.  
- Tutor-moderated discussion forums to build the argumentation skills that webinars assess.  
- Balanced assessment weightings alongside written assignments and MCQs to test both knowledge and application.  

These elements are embedded in our **Master of Arts in Global Business & Strategic Leadership** and align with ESBD’s quality and student-experience commitments.

`,
    image: `/image-fix/news-images/pexels-photo-5965673.jpeg.jpg`,
    image400: "/image-fix/news-images/out/pexels-photo-5965673.jpeg-400.jpg",
    image800: "/image-fix/news-images/out/pexels-photo-5965673.jpeg-800.jpg",
    buttonavaliability: false,
    buttonName: "Read Paper",
    buttonlink:
      "https://ijbmcjournals.org/wp-content/uploads/2024/01/IJBA-4-1-33.pdf",
  },
];
